/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-03",
    versionChannel: "nightly",
    buildDate: "2025-06-03T00:06:53.159Z",
    commitHash: "b55a2fd8e1bf7e588af108ff450f2fe441e139d7",
};
